import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import {analytics} from '../../common/baseData';
import TopProduct from '../categoryPage/catalogItem/TopProduct';
import SimpleProduct from '../categoryPage/catalogItem/SimpleProduct';
import PromoProduct from '../categoryPage/catalogItem/PromoProduct';
import {eventEmitter} from '../../common/baseData';

function ProductList(props) {
  const [products, setProducts] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const {ref, inView} = useInView({
    threshold: 0, triggerOnce: true,
  });
  const [productIds, setProductIds] = useState([]);

  /**
   * Сортировка товаров
   */
  useEffect(() => {
    let items = [...props.itemsList];

    items.sort((a, b) => {
      return Number(a.ID) === Number(props.topElementID) ? -1 : 0;
    });

    // Извлекаем массив ID из itemsList
    const ids = props.itemsList.map(item => item.ID);

    // Устанавливаем его в состояние productIds
    setProductIds(ids);

    setProducts(items);
  }, [props.itemsList]);

  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < 768);

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // GA4 / sending item list view event
  useEffect(() => {
    if (!productIds.length) return;
    analytics.viewItemList(productIds, 'Category Products',
        'category_products').then(response => {
      analytics.view_item_list(response.events[0].params);
      console.info(response);
    }).catch(reason => (console.error(reason)));
  }, [productIds]);

  useEffect(() => {
    let catalogProductBlock = document.querySelector('[data-container="product-list-dynamic"]');

    if (catalogProductBlock instanceof HTMLElement) {
      // Wishlist
      eventEmitter.emit('handleWishlistItems', {
        node: catalogProductBlock.querySelectorAll('[data-container="favorite"]'),
        range: 'category',
      });

      // Compare
      eventEmitter.emit('handleCompareItems', {
        node: catalogProductBlock.querySelectorAll('[data-container="compare"]'),
        range: 'category',
      });
    }
  }, [products]);

  function onClick(item_id, url) {
    analytics.selectItem(item_id, 'Category Products', 'category_products').
        then(response => {
          analytics.select_item(response.data.params);
          //console.info(response, item_id)
          window.location.href = url;
        }).
        catch(reason => {
          console.error(reason);
          window.location.href = url;
        });
  }

  return (
      <div className={props.className ? props.className : ''} key={props.key} data-container="product-list-dynamic">
        {
          products.length ? products.map((product, index) => {
              let promoForThisIndex = null;
              if (props.sectionPromo !== null)
                promoForThisIndex = props.sectionPromo.find(promo => Number(promo.listIndex) === index + 1);

                return promoForThisIndex ?
                    <>
                      <PromoProduct promoData={promoForThisIndex} key={'promo'}/>
                      <SimpleProduct key={`simple-${product.XML_ID}`} data={product}
                                     messages={props.messages}
                                     isMobile={isMobile}
                                     newModelsCategory={props.newModelsCategory}
                                     onClick={onClick}/>
                    </>:
                    Number(product.ID) === Number(props.topElementID) ?
                        <TopProduct key={`top-${product.XML_ID}`} data={product}
                                    messages={props.messages}
                                    isMobile={isMobile}
                                    newModelsCategory={props.newModelsCategory}
                                    onClick={onClick}/> :
                        <SimpleProduct key={`simple-${product.XML_ID}`} data={product}
                                       messages={props.messages}
                                       isMobile={isMobile}
                                       newModelsCategory={props.newModelsCategory}
                                       onClick={onClick}/>;
              }) :
              <></>
        }
      </div>
  );
}

export default ProductList;